import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container text-center extra-large-space pt-5"
};
const _hoisted_2 = {
  class: "row d-flex justify-content-center"
};
const _hoisted_3 = {
  class: "col-lg-4 col-sm-6 col-10"
};
const _hoisted_4 = {
  class: "d-flex justify-content-between"
};
import { useMeta } from "vue-meta";
import CloudinaryImage from "@/components/CloudinaryImage.vue";
export default {
  __name: 'notFound',
  setup(__props) {
    useMeta({
      title: "Page Not Found"
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(CloudinaryImage, {
        class: "w-25",
        imageName: "dog_error_tbdn96"
      }), _cache[3] || (_cache[3] = _createElementVNode("h5", {
        class: "text-black px-3"
      }, " Oops! The page you're looking for isn't available at the moment. ", -1)), _cache[4] || (_cache[4] = _createElementVNode("h6", {
        class: "my-4 px-3"
      }, "But no worries-here are some helpful links to get you back on track:", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
        to: "/",
        class: "help-link"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode(" Home ")])),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/faq",
        class: "help-link"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" Help center ")])),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "contact-us",
        class: "help-link"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" Contact ")])),
        _: 1
      })])])])])]);
    };
  }
};